import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _999675e2 = () => interopDefault(import('../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _c3e1f8ba = () => interopDefault(import('../pages/newsletter.vue' /* webpackChunkName: "pages/newsletter" */))
const _0ec20990 = () => interopDefault(import('../pages/szukaj.vue' /* webpackChunkName: "pages/szukaj" */))
const _520b67ee = () => interopDefault(import('../pages/zycko.vue' /* webpackChunkName: "pages/zycko" */))
const _0972424c = () => interopDefault(import('../pages/blog/nasze-kierunki/index.vue' /* webpackChunkName: "pages/blog/nasze-kierunki/index" */))
const _12abf080 = () => interopDefault(import('../pages/lp/aplikacja-mobilna.vue' /* webpackChunkName: "pages/lp/aplikacja-mobilna" */))
const _1643686c = () => interopDefault(import('../pages/lp/archiwum-regulaminow-promocji.vue' /* webpackChunkName: "pages/lp/archiwum-regulaminow-promocji" */))
const _56427f3a = () => interopDefault(import('../pages/lp/dla-firm.vue' /* webpackChunkName: "pages/lp/dla-firm" */))
const _0c158dd0 = () => interopDefault(import('../pages/lp/egzotyka-2022.vue' /* webpackChunkName: "pages/lp/egzotyka-2022" */))
const _954246a0 = () => interopDefault(import('../pages/lp/egzotyka-2022-promocja.vue' /* webpackChunkName: "pages/lp/egzotyka-2022-promocja" */))
const _0bf95ece = () => interopDefault(import('../pages/lp/egzotyka-2023.vue' /* webpackChunkName: "pages/lp/egzotyka-2023" */))
const _4e19fb4f = () => interopDefault(import('../pages/lp/egzotyka-tuz-za-rogiem.vue' /* webpackChunkName: "pages/lp/egzotyka-tuz-za-rogiem" */))
const _32a384d5 = () => interopDefault(import('../pages/lp/figlokluby.vue' /* webpackChunkName: "pages/lp/figlokluby" */))
const _42ec7143 = () => interopDefault(import('../pages/lp/filmowy-swiat-rainbow/index.vue' /* webpackChunkName: "pages/lp/filmowy-swiat-rainbow/index" */))
const _139454c1 = () => interopDefault(import('../pages/lp/happy-hours.vue' /* webpackChunkName: "pages/lp/happy-hours" */))
const _28ccc5a8 = () => interopDefault(import('../pages/lp/hotele-elite.vue' /* webpackChunkName: "pages/lp/hotele-elite" */))
const _05f9ea8c = () => interopDefault(import('../pages/lp/hotele-white-olive.vue' /* webpackChunkName: "pages/lp/hotele-white-olive" */))
const _d04b7252 = () => interopDefault(import('../pages/lp/informatsiya-dla-hromadian-ukrainy.vue' /* webpackChunkName: "pages/lp/informatsiya-dla-hromadian-ukrainy" */))
const _78ec5653 = () => interopDefault(import('../pages/lp/karty-bony-vouchery.vue' /* webpackChunkName: "pages/lp/karty-bony-vouchery" */))
const _7def4d19 = () => interopDefault(import('../pages/lp/katalogi.vue' /* webpackChunkName: "pages/lp/katalogi" */))
const _1753d1b6 = () => interopDefault(import('../pages/lp/kim-jestesmy.vue' /* webpackChunkName: "pages/lp/kim-jestesmy" */))
const _66bc0c30 = () => interopDefault(import('../pages/lp/koncoweczka.vue' /* webpackChunkName: "pages/lp/koncoweczka" */))
const _1e0e65e1 = () => interopDefault(import('../pages/lp/lato.vue' /* webpackChunkName: "pages/lp/lato" */))
const _dc51f4ca = () => interopDefault(import('../pages/lp/lato-2023.vue' /* webpackChunkName: "pages/lp/lato-2023" */))
const _0aa3b1be = () => interopDefault(import('../pages/lp/najlepsze-wycieczki-objazdowe.vue' /* webpackChunkName: "pages/lp/najlepsze-wycieczki-objazdowe" */))
const _483d0c48 = () => interopDefault(import('../pages/lp/praca.vue' /* webpackChunkName: "pages/lp/praca" */))
const _81fc217a = () => interopDefault(import('../pages/lp/supersroda.vue' /* webpackChunkName: "pages/lp/supersroda" */))
const _02464fde = () => interopDefault(import('../pages/lp/topniejace-rabaty.vue' /* webpackChunkName: "pages/lp/topniejace-rabaty" */))
const _4e38c508 = () => interopDefault(import('../pages/lp/uslugi-lotniskowe.vue' /* webpackChunkName: "pages/lp/uslugi-lotniskowe" */))
const _931036e0 = () => interopDefault(import('../pages/lp/wczasy-dojazd-wlasny.vue' /* webpackChunkName: "pages/lp/wczasy-dojazd-wlasny" */))
const _f591e5ac = () => interopDefault(import('../pages/lp/zima-pod-palmami.vue' /* webpackChunkName: "pages/lp/zima-pod-palmami" */))
const _2633cc27 = () => interopDefault(import('../pages/blog/kategorie/_id.vue' /* webpackChunkName: "pages/blog/kategorie/_id" */))
const _730e6ee6 = () => interopDefault(import('../pages/blog/tagi/_id.vue' /* webpackChunkName: "pages/blog/tagi/_id" */))
const _18c41b6a = () => interopDefault(import('../pages/lp/filmowy-swiat-rainbow/_sezon/index.vue' /* webpackChunkName: "pages/lp/filmowy-swiat-rainbow/_sezon/index" */))
const _b0191b86 = () => interopDefault(import('../pages/blog/nasze-kierunki/_slug/_id.vue' /* webpackChunkName: "pages/blog/nasze-kierunki/_slug/_id" */))
const _34799a86 = () => interopDefault(import('../pages/lp/filmowy-swiat-rainbow/_sezon/_odcinek/_id.vue' /* webpackChunkName: "pages/lp/filmowy-swiat-rainbow/_sezon/_odcinek/_id" */))
const _1f67019f = () => interopDefault(import('../pages/biura/_miasto/index.vue' /* webpackChunkName: "pages/biura/_miasto/index" */))
const _64c8920a = () => interopDefault(import('../pages/blog/_article.vue' /* webpackChunkName: "pages/blog/_article" */))
const _9ef973dc = () => interopDefault(import('../pages/biura/_miasto/_biuro/index.vue' /* webpackChunkName: "pages/biura/_miasto/_biuro/index" */))
const _2dfb1658 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _5bd6e4b0 = () => interopDefault(import('../pages/biura/_miasto/index.vue' /* webpackChunkName: "" */))
const _d36d0242 = () => interopDefault(import('../pages/szukaj.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/blog",
    component: _999675e2,
    name: "blog"
  }, {
    path: "/newsletter",
    component: _c3e1f8ba,
    name: "newsletter"
  }, {
    path: "/szukaj",
    component: _0ec20990,
    props: true,
    name: "szukaj"
  }, {
    path: "/zycko",
    component: _520b67ee,
    name: "zycko"
  }, {
    path: "/blog/nasze-kierunki",
    component: _0972424c,
    name: "blog-nasze-kierunki"
  }, {
    path: "/aplikacja-mobilna",
    component: _12abf080,
    name: "lp-aplikacja-mobilna"
  }, {
    path: "/archiwum-regulaminow-promocji",
    component: _1643686c,
    name: "lp-archiwum-regulaminow-promocji"
  }, {
    path: "/dla-firm",
    component: _56427f3a,
    name: "lp-dla-firm"
  }, {
    path: "/egzotyka-2022",
    component: _0c158dd0,
    name: "lp-egzotyka-2022"
  }, {
    path: "/egzotyka-2022-promocja",
    component: _954246a0,
    name: "lp-egzotyka-2022-promocja"
  }, {
    path: "/egzotyka-2023",
    component: _0bf95ece,
    name: "lp-egzotyka-2023"
  }, {
    path: "/egzotyka-tuz-za-rogiem",
    component: _4e19fb4f,
    name: "lp-egzotyka-tuz-za-rogiem"
  }, {
    path: "/figlokluby",
    component: _32a384d5,
    name: "lp-figlokluby"
  }, {
    path: "/filmowy-swiat-rainbow",
    component: _42ec7143,
    name: "lp-filmowy-swiat-rainbow"
  }, {
    path: "/happy-hours",
    component: _139454c1,
    name: "lp-happy-hours"
  }, {
    path: "/hotele-elite",
    component: _28ccc5a8,
    name: "lp-hotele-elite"
  }, {
    path: "/hotele-white-olive",
    component: _05f9ea8c,
    name: "lp-hotele-white-olive"
  }, {
    path: "/informatsiya-dla-hromadian-ukrainy",
    component: _d04b7252,
    name: "lp-informatsiya-dla-hromadian-ukrainy"
  }, {
    path: "/karty-bony-vouchery",
    component: _78ec5653,
    name: "lp-karty-bony-vouchery"
  }, {
    path: "/katalogi",
    component: _7def4d19,
    name: "lp-katalogi"
  }, {
    path: "/kim-jestesmy",
    component: _1753d1b6,
    name: "lp-kim-jestesmy"
  }, {
    path: "/koncoweczka",
    component: _66bc0c30,
    name: "lp-koncoweczka"
  }, {
    path: "/lato",
    component: _1e0e65e1,
    name: "lp-lato"
  }, {
    path: "/lato-2023",
    component: _dc51f4ca,
    name: "lp-lato-2023"
  }, {
    path: "/najlepsze-wycieczki-objazdowe",
    component: _0aa3b1be,
    name: "lp-najlepsze-wycieczki-objazdowe"
  }, {
    path: "/praca",
    component: _483d0c48,
    name: "lp-praca"
  }, {
    path: "/supersroda",
    component: _81fc217a,
    name: "lp-supersroda"
  }, {
    path: "/topniejace-rabaty",
    component: _02464fde,
    name: "lp-topniejace-rabaty"
  }, {
    path: "/uslugi-lotniskowe",
    component: _4e38c508,
    name: "lp-uslugi-lotniskowe"
  }, {
    path: "/wczasy-dojazd-wlasny",
    component: _931036e0,
    name: "lp-wczasy-dojazd-wlasny"
  }, {
    path: "/zima-pod-palmami",
    component: _f591e5ac,
    name: "lp-zima-pod-palmami"
  }, {
    path: "/blog/kategorie/:id?",
    component: _2633cc27,
    name: "blog-kategorie-id"
  }, {
    path: "/blog/tagi/:id?",
    component: _730e6ee6,
    name: "blog-tagi-id"
  }, {
    path: "/filmowy-swiat-rainbow/:sezon",
    component: _18c41b6a,
    name: "lp-filmowy-swiat-rainbow-sezon"
  }, {
    path: "/blog/nasze-kierunki/:slug?/:id",
    component: _b0191b86,
    name: "blog-nasze-kierunki-slug-id"
  }, {
    path: "/filmowy-swiat-rainbow/:sezon?/:odcinek?/:id",
    component: _34799a86,
    name: "lp-filmowy-swiat-rainbow-sezon-odcinek-id"
  }, {
    path: "/biura/:miasto",
    component: _1f67019f,
    name: "biura-miasto"
  }, {
    path: "/blog/:article",
    component: _64c8920a,
    name: "blog-article"
  }, {
    path: "/biura/:miasto?/:biuro",
    component: _9ef973dc,
    name: "biura-miasto-biuro"
  }, {
    path: "/",
    component: _2dfb1658,
    name: "index"
  }, {
    path: "/biura",
    component: _5bd6e4b0
  }, {
    path: "/*",
    component: _d36d0242
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
